'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = modal;
exports.show = show;
exports.hide = hide;
exports.setReasonVal = setReasonVal;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW = 'modal/SHOW';
var HIDE = 'modal/HIDE';
var SET_REASON_VAL = 'modal/SET_REASON_VAL';

var initialState = {
  show: false,
  reason: 0
};

function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SHOW:
      return (0, _extends3.default)({}, state, {
        show: true,
        module: action.module
      });
    case HIDE:
      return (0, _extends3.default)({}, state, {
        show: false
      });
    case SET_REASON_VAL:
      return (0, _extends3.default)({}, state, {
        reason: action.reason
      });
    default:
      return state;
  }
}

function show(module) {
  return {
    type: SHOW,
    module: module
  };
}
function hide() {
  return {
    type: HIDE
  };
}
function setReasonVal(reason) {
  return {
    type: SET_REASON_VAL,
    reason: reason
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/modal.js
// module id = 162
// module chunks = 0